import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebaseConfig } from "./config";

// Lazy: initialising with missing VUE_APP_FIREBASE_* values throws (auth/invalid-api-key), and that must
// surface on the sign-in click, not break the whole app at import time.
export function getFirebaseAuth() {
  const app = getApps()[0] || initializeApp(firebaseConfig);

  return getAuth(app);
}
